import request from '@/utils/request'

export default {
    getClients: async({ dispatch, commit }, scope) => {
        if (scope === 'selected') {
            commit('SET_NORMALIZE_PHONES', null)
            commit('SET_CLIENTS', [])
            commit('SET_COUNT', 0)
        } else {
            await request({ method: 'get', url: '/notifications/clients/' + scope, timeout: 50000 }) // TODO
                .then(res => {
                    if (res.data) {
                        commit('SET_COUNT', res.data.count)
                        commit('SET_CLIENTS', res.data.clientPhones)
                    }
                })
        }
    },
    sendPushNotification: async({ dispatch, state, commit }, data) => {
        commit('SET_LOAD', true)

        const requestData = {
            data: {
                sendTo: state.filters.sendTo,
                title: state.notification.title,
                body: state.notification.body,
                image: state.notification.image
            },
            phones: state.filters.sendTo === 'selected' ? state.filters.phones.split('\n').filter(i => !!i) : undefined
        }

        await request({
            method: 'post', url: '/notifications', data: requestData, timeout: 50000
        }).then(res => {
            if (res.data && res.data.android && res.data.ios) {
                commit('SET_RESULT', res.data)
                commit('SET_LOAD', false)
                commit('CLEAR_NOTIFICATION', null)
            }
        })
    },
    validatePhones: async({ dispatch, commit }, phones) => {
        if (phones.length) {
            commit('SET_LOAD', true)
        }
        await request({
            method: 'post', url: '/notifications/client/validate-phones', data: { phones }, timeout: 50000
        }).then(res => {
            if (res.data) {
                commit('SET_NORMALIZE_PHONES', res.data)

                if (res.data.success && res.data.success.length) {
                    commit('SET_PHONES', res.data.success.map('phone').join('\n'))
                    commit('SET_COUNT', res.data.success.length)
                } else {
                    commit('SET_PHONES', '')
                    commit('SET_COUNT', 0)
                }
                commit('SET_LOAD', false)
            }
        })
    }
}
